module.exports = __webpack_public_path__ + "img/海外仓备货模式.4bcd10b4.png";